/**
 * SignOutDialog. Asks before ending the session, so a stray click in the
 * account menu or the command palette never signs anyone out by surprise.
 * Shared by both entry points.
 */

import { useNavigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { ConfirmDialog } from "@/primitives/overlays";
import { ROUTES } from "@/types/routes";
import { useTenant } from "@/lib/tenant";

export function SignOutDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { displayName } = useTenant();
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={async () => {
        await logout();
        navigate(ROUTES.LOGIN, { replace: true });
      }}
      title={`Sign out of ${displayName}?`}
      body="You'll need to sign in again to get back to your workspace."
      confirmLabel="Sign out"
      cancelLabel="Stay signed in"
      danger={false}
      errorLabel="We couldn't sign you out just now. Give it another go."
    />
  );
}
